const colors = {
    accent: '#6366f1',
    background: '#f8fafc',
    error: '#f03',
    foreground: '#000',
    gray: '#64748b',
    highlight: '#818cf8',
    hover: '#cbd5e1',
    'light-gray': '#cbd5e1',

    selected: '#dfe0fc',
    success: '#2e7d32',
    warning: '#ed6c02',
};

export default colors;
